import {css} from 'styled-components';

/**
 * Shared look for a page-level tab bar that carries a filter bar in its extra-content slot.
 *
 * Extracted from StyledExpensesPanelTabs, which was the first to get this treatment; the Invoices
 * and NetSuite (Bills / Journal Entries / Vendors) tabs now share it rather than each re-declaring
 * the same nav and extra-content rules.
 *
 * Interpolate it first in a styled(Tabs) template so a page can override anything after it:
 *
 *   const StyledJournalEntriesTabs = styled(Tabs)`
 *     ${panelTabsStyles};
 *     .ant-tabs-content-holder { padding: 24px 0; }
 *   `;
 *
 * Assumes borderless line tabs — it clears the card background and border, so consumers should not
 * pass `type='card'`.
 */
export const panelTabsStyles = css`
  .ant-tabs-nav {
    margin-bottom: 0;
  }

  /* The filter bar lives in this slot, so it has to be allowed to shrink — without min-width the
     flex item keeps its content width and pushes the nav row past the container instead of
     scrolling inside it. The max-width reserves room for the overflow ("...") button;
     --tabs-operations-width defaults to 0px unless a page measures it, as ExpensesPanel does. */
  .ant-tabs-extra-content {
    min-width: 0;
    max-width: calc(100% - var(--tabs-operations-width, 0px));
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .ant-tabs-content-holder {
    background-color: unset;
    border: none;
    padding: 16px 0 0 0;
    min-height: calc(100vh - 64px - (16px * 2) - (24px * 2) - 40px);
  }
`;
